
import { Component, ViewChild, HostListener } from "@angular/core";
import { ActivatedRoute, Router} from "@angular/router";
import { AfterViewInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import {MatTabChangeEvent, MatTabGroup} from '@angular/material/tabs';
import { MatDialog } from "@angular/material/dialog";
import { Title } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { AESCodecService } from "../../../../services/AESCodecService";
import { SenetAceEditor, ConfirmDialog } from "aes-common";
import { AESAccountService, Account } from "../../../../services/AESAccountService";
import { Utils } from "../../../../services/Utils";

@Component({
    selector: 'codecdetails',
    templateUrl: 'codec-details.html',
    styleUrls: ['./codec-details.scss']
})
export class CodecDetails implements AfterViewInit {
    @ViewChild('codecCodeEditor', {static: true}) codecCodeEditor: SenetAceEditor;
    @ViewChild('downlinkCodeEditor', {static: true}) downlinkCodeEditor: SenetAceEditor;
    @ViewChild("tabGroup", { static: false }) tabGroup: MatTabGroup;

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) { 
        if((event.ctrlKey || event.metaKey) && event.key == 's'){
            event.preventDefault();
            this.save(false);
        }
    }

    codecId: string;
    instance: any;
    editType: string = "Create";
    titleSuffix: string;
    title: string;
    accounts: Account[]

    inProgress: boolean = false;
    saveBlocked: boolean;
    error: string;
    mode : string = "ace/mode/javascript";
    isShared : boolean = false;
    codeChanged: boolean = false;
    changed: boolean = false;
    canShow: boolean = false;
    selectedTab: number = 0;
    codecDefault: string = "\nfunction decodeUplink(input){\n    var output = {\n        \"data\" : {},\n        \"errors\": [],\n        \"warnings\" : []\n    }\n    var bytes = Buffer.from(input.bytes);\n    var port = input.fport;\n    output.errors.push(\"Not Supported\");\n    return output;\n}\n\nfunction encodeDownlink(input){\n    var output = {\n        \"fport\" : 0,\n        \"bytes\" : [],\n        \"errors\" : [],\n        \"warnings\" : []\n    };\n    output.errors.push(\"Not Supported\");\n    return output;\n}\n\nfunction decodeDownlink(input){\n    var output = {\n        \"data\" : {},\n        \"errors\": [],\n        \"warnings\" : []\n    }\n    output.errors.push(\"Not Supported\");\n    return output;\n}\n\nfunction getDownlinks(){\n    var output = {\n        \"Example Command\" : {\n             \"exampleParam\":{\n                \"description\":\"Example parameter\",\n                \"type\":\"integer\",\n                \"required\":true,\n                \"max\":86400,\n                \"min\":30,\n                \"default\":60\n            }\n        }\n    };\n\n    return output;\n}\n\nfunction getUplinks(){\n    var output = {\n        \"example\" : {\n            \"description\" : \"Example uplink output\",\n            \"type\" : \"float\"\n        }\n    };\n\n\n    return output;\n}\n\nfunction getDownlinkExamples(){\n    var output = {\n        \"control\" : \"Pir\",\n        \"parameters\" : {\n            \"gracePeriod\" : 300,\n            \"threshold\" : 1,\n            \"period\" : 15,\n            \"countTx\" : false,\n            \"stateTx\" : false,\n            \"thresholdEnabled\" : true,\n            \"pirState\" : true\n        }\n    };\n\n\n    return output;\n}\n    \nfunction getUplinkExamples(){\n    var output = [0x03, 0x67, 0xFF, 0xFF, 0xFF, 0xFF];\n    return output;\n}\n\nvar TemplateCodec = {};\nTemplateCodec.decodeUplink = decodeUplink;\nTemplateCodec.encodeDownlink = encodeDownlink;\nTemplateCodec.decodeDownlink = decodeDownlink;\nTemplateCodec.getDownlinks = getDownlinks;\nTemplateCodec.getUplinks = getUplinks;\nTemplateCodec.getDownlinkExamples = getDownlinkExamples;\nTemplateCodec.getUplinkExamples = getUplinkExamples;\n\nmodule.exports = TemplateCodec;";
    downlinkCodeDefault : string =  'module.exports = function(input, dev, rootScope, functionBlocksCfg){\nreturn new Promise((resolve) => {\n        resolve(input);\n    });\n};';

    //2 Code editors
    firstCodeChangeEvent1: boolean = true;
    firstCodeChangeEvent2: boolean = true;
    gapSize: string = "10px";
    private canGoBack: boolean;
    private oldInst: any;

    constructor(public dialog: MatDialog, private route: ActivatedRoute, public serve : AESCodecService,
        public snackBar: MatSnackBar, public titleService: Title, private router: Router, private location: Location, public accountSearch: AESAccountService) {
        let me = this;
        this.codecId = this.route.snapshot.params["id"];
        this.canGoBack = !!(this.router.getCurrentNavigation()?.previousNavigation);
        this.instance = {};

        if(this.codecId == '-1'){
            this.instance.codecCode = this.codecDefault;
            this.oldInst = {...this.instance};
            this.canShow = true;   
        }else{
            this.inProgress = true;
            this.serve.get(this.codecId).subscribe(res => {
                var inst = res;
                if (inst != undefined) {
                    this.instance = {...inst};
                    this.editType = "Edit";
                    this.instance.downlinkCodeEnabled = this.instance.downlinkCode != undefined && this.instance.downlinkCode != "";
                    this.isShared = this.instance.acctId == null;
                }

                this.titleService.setTitle(this.title);//Overridden if defined in app-routing module.ts
                if(this.instance.name != undefined && this.instance.name != ""){
                    this.titleSuffix = " - " + this.instance.name;
                }
                
                this.oldInst = {...this.instance};
                this.inProgress = false;
                this.canShow = true;
            }, err =>{
                this.openSnackBar("Unable to load Codec: " + this.codecId, undefined);
                this.inProgress = false;
            }); 
        } 
        if(Utils.isAdminUser()){
            accountSearch.search(undefined, undefined, undefined, undefined, undefined, undefined)
            .subscribe(data => {
                me.accounts = data.data;
                me.accounts.splice(0, 0, {"name" : "None", "acctId" : -2, "connectionType" : "", "creationDate" : null, "desciption" : "", "defaultConnectionId": -1});
                if(me.accounts == undefined || me.accounts.length == 0){
                    me.error = "Unable to load accounts, please try again later or contact an administrator.";
                }
                else{
                    me.inProgress = false;
                    if(me.instance.acctId == undefined){
                        me.instance.acctId = data.data[0].acctId;
                    }
                }
            }, (err) => {
            me.error = "Unable to load accounts, please try again later or contact an administrator.";
            });
        }
    }
    isAdmin(){
        return Utils.isAdminUser();
    }
    ngOnInit() {      
    }
    ngAfterViewInit(){ 
        const tabGroup = this.tabGroup;
        if (!tabGroup || !(tabGroup instanceof MatTabGroup)) return;
      
        tabGroup.selectedIndex = this.selectedTab;           
    }
    handleDownlinkEnabled(enabled){
        if(enabled){
            this.instance.downlinkCode = this.downlinkCodeDefault;
        }
    }

    handleBack($event){
        $event.preventDefault();
        this.cancel();
    }
    selectedTabChanged(tabChangeEvent: MatTabChangeEvent){
        let index = tabChangeEvent.index;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {"tab": index},
            replaceUrl: true,
            queryParamsHandling: 'merge'

        });        
    }
    isDirty(){
        if(!this.changed && this.oldInst){
            this.changed = JSON.stringify(this.oldInst) != JSON.stringify(this.instance);
        }
        return this.changed;
    }
    save(backOnSave:boolean = true) {
        this.error = "";
        if(this.inProgress || this.saveBlocked || !this.isDirty()){
            return;
        }
        if(this.isShared && !this.isAdmin()){
            this.error = "Cannot edit a shared Codec";
            return;
        }
        let codeAnnErrors = this.codecCodeEditor.getAnnotationErrors();
        let downlinkAnnErrors = this.downlinkCodeEditor.getAnnotationErrors();

        if(codeAnnErrors.length > 0){
            let firstError = codeAnnErrors[0];
            let errLine = firstError.row + 1;
            let errCol = firstError.column + 1;
            let errText = firstError.text;
            this.error = "Codec Code Error: " + errText + " at line " + errLine + " column " + errCol;
            return;
        }
        if(downlinkAnnErrors.length > 0){
            let firstError = downlinkAnnErrors[0];
            let errLine = firstError.row + 1;
            let errCol = firstError.column + 1;
            let errText = firstError.text;
            this.error = "Codec Downlink Error: " + errText + " at line " + errLine + " column " + errCol;
            return;
        }        
        if(this.instance.codecCode == undefined || this.instance.codecCode == ""){
            this.error = "A codec code is required";
            return;
        }
        if(this.instance.name == undefined || this.instance.name == ""){
            this.error = "An name is required";
            return;
        }
        if(this.instance.downlinkCodeEnabled && (this.instance.downlinkCode == undefined || this.instance.downlinkCode == "")){
            this.error = "A downlink code is required";
            return;
        }
        if(this.instance.acctId == -2){//Clear account ID
            this.instance.acctId = null;
        }
        let me = this;
        let obs;
        this.inProgress = true;
        if(this.editType == "Create"){
            obs = this.serve.create(this.instance);
        }
        else{
            obs = this.serve.edit(this.instance);
        }

        obs.subscribe(resp => {
            me.oldInst = {...me.instance};
            me.inProgress = false;
            me.changed = false;
            if(backOnSave){
                me.goBack(me);
            }
        }, (err) => {
            me.inProgress = false;
            me.changed = false;            
            console.log(err);
            if(err && err.error && err.error.message){
                me.error = err.error.message;
                if(me.error == "Internal Server Error"){
                   me.error = "Server was unable to process your request";
                }
            }else{
                me.error = JSON.stringify(err);
                if(!me.error){
                    "An unknown server error occurred";
                }
            }
        });
    }
    onCodeChanged(codeId){
        if(!this.firstCodeChangeEvent1 && !this.firstCodeChangeEvent2){
            this.codeChanged = true;
        }
        if(codeId == 'codecCodeEditor'){
            this.firstCodeChangeEvent1 = false;
        }
        if(codeId == 'downlinkCodeEditor'){
            this.firstCodeChangeEvent2 = false;
        }        
    }    
    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 2000,
            horizontalPosition: 'right'
        });
    } 

    calculateSize(percent) {
        if (percent == undefined) {
            percent = 100;
        }
        if (!isNaN(percent)) {
            percent = percent + "%";
        }
        else {
            percent = percent.toString();
            if (percent.index("%") < 0) {
                percent += "%";
            }
        }
        if (this.gapSize == undefined) {
            return percent;
        }
        return "calc(" + percent + " - " + this.gapSize + ")"
    } 

    cancel(){
        let me = this;
        if(me.changed){
            me.dialog.open(ConfirmDialog, {
                width: '600px',
                data: {
                    "title" : "Unsaved Changes",
                    "message" : "There are unsaved changes, are you sure you want to leave?",
                    "success": function(){
                        me.goBack(me);
                    }
                }
            });             
        }else{
            me.goBack(me);
        } 
    }  
    goBack(me){
        if(me.canGoBack){
            me.location.back();
        }else{
            me.router.navigateByUrl("/configurations/codecs",{
                replaceUrl: true
            });
        }
    }   
    
}
